import _ from 'lodash';
import moment from 'moment';

const getValuesMultipleSort = (a, b, keys) => {
  let first;
  let second;

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const aValue = _.get(a, key);
    const bValue = _.get(b, key);

    if (i === keys.length - 1 || aValue !== bValue) { // If key is last, or values by that key are different (For multiple key sort)
      first = aValue;
      second = bValue;
    }
  }

  return [first, second];
};

export const createSortingFunction = (orderType, ...keys) => (
  (a, b) => {
    let first = a; let
      second = b;

    if (keys.length > 1) [first, second] = getValuesMultipleSort(a, b, keys);
    else if (keys.length) {
      const key = keys[0];
      first = _.get(a, key);
      second = _.get(b, key);
    }

    return orderType === 'asc'
      ? first - second
      : second - first;
  }
);

export const ascSort = _.partial(createSortingFunction, 'asc');
export const descSort = _.partial(createSortingFunction, 'desc');

export const ascNegativeLastSort = (key) => (
  (first, second) => {
    const a = key ? first?.[key] : first;
    const b = key ? second?.[key] : second;

    if (a < 0) return 1;
    if (b < 0) return -1;

    return a - b;
  }
);

export const ascAlphabeticalSort = (key) => (
  (first, second) => {
    const a = key ? first?.[key] : first;
    const b = key ? second?.[key] : second;

    return a.localeCompare(b);
  }
);

export const descDateSort = (key) => (
  (first, second) => {
    const a = key ? first?.[key] : first;
    const b = key ? second?.[key] : second;

    return moment(b).unix() - moment(a).unix();
  }
);
